//import request from '@/Utilities/httpRequest';
import homeUtils from '@/Utilities/homeUtils';
import browser from '@/Utilities/browser';

import homeProduct from './Home/home-product';
import homeAdvantage from './Home/home-advantage';

export default class HomeBlock {
    
    constructor(url, config, order) {
        this.itensVp      = 5;
        this.platform     = config.hasOwnProperty('platform') ? config.platform : 1;
        this.contentType  = 'product';
        this.key          = config.key;
        this.sKey         = config.sKey;
        this.title        = config.title;
        this.subTitle     = config.hasOwnProperty('subTitle') ? config.subTitle : null;
        this.titleBanner  = config.hasOwnProperty('titleBanner') ? config.titleBanner : null;
        this.min          = config.min;
        this.max          = config.max;
        this.showMore     = null; //config.showMore;
        this.ttl          = config.ttl;
        this.order        = order;
        this.url          = url;
        this.dataContent  = null;
        this.blkitens     = null;
        this.loading      = true;
        this.mub          = config.hasOwnProperty('mub') ? config.mub : null;
        this.matrixProds  = null;
        this.hoverAndZoom = true;
        this.advantages   = config.hasOwnProperty('advantages') ? config.advantages : null;

        this.type         = config.type;
        this.lock         = false;
        this.otiKey       = null;

        this.diamond      = config.hasOwnProperty('diamond') ? config.diamond : null;
        if(config.hasOwnProperty('data') && config.data){
            this.setData(config.data);
        }else{
            this.readCache(true);
        }
//        this.pastimeConfig      = config.hasOwnProperty('pastimeConfig') ? config.pastimeConfig : null;
    }
    
    set type(value) {
        
        this.bType = null;
        switch(value){
            case 'productsSlide': case 'NORMALPRODUCTS': case 'squareSlide': 
                this.bType = 'NormalProducts';
                this.itensVp = this.platform == 1 ? 5 : 1.2;
                break;
            case 'MEDIUMPRODUCTS':
                this.bType = 'NormalProducts';
                this.itensVp = this.platform == 1 ? 4 : 1.2;
                break;
            case 'combosSlide':
            case 'COMBOPRODUCT':
                this.bType = 'ComboProducts';
                this.itensVp = this.platform == 1 ? 2.5 : 1.2;
                this.contentType  = 'combo';
                //this.min = 6;
                break;
            case 'bannerSlide': case 'NORMALBANNER':
                this.bType = 'BannerSlide';
                this.itensVp = this.platform == 1 ? 2.5 : 1.2;
                this.contentType  = 'banner'; 
                break;
            case 'bannerPrioritySlide': case 'PRIORITYBANNER':
                this.bType = 'PriorityBanner';
                this.itensVp = 1;
                this.contentType  = 'banner'; 
                break;
            case 'productsFull': case 'VERTICALPRODUCTS':
                this.bType = 'VerticalProducts';
                this.itensVp = this.platform == 1 ? 5 : 1.2;
                break;
            case 'FULLPRODUCTS': case 'FIRSTBLOCKPRODUCTS':
                this.bType = this.platform == 1 ? 'NormalProducts' : 'SlickProducts';
                this.itensVp = this.platform == 1 ? 5 : 1;
                break;
            case 'FIRSTBLOCKRANKING':
                this.bType = this.platform == 1 ? 'RankingProducts' : 'SlickRanking';
                this.itensVp = this.platform == 1 ? 5 : 1;
                break;
            case 'RANKINGPRODUCTS':
                this.bType = 'RankingProducts';
                this.itensVp = this.platform == 1 ? 5 : 1.2;
                break;
            case 'HORIZONTALPRODUCTS':
                this.bType = this.platform == 1 ? 'HorizontalProducts' :'NormalProducts';
                this.itensVp = this.platform == 1 ? 2.5 : 1.2;
                break;
            case 'DIAMOND_MOBILE':
                this.bType = 'HorizontalProducts';
                this.itensVp = 1.2;
                break;
            case 'BIGHORIZONTALPRODUCTS':
                this.bType = this.platform == 1 ? 'HorizontalProducts' :'NormalProducts';
                this.itensVp = this.platform == 1 ? 1.25 : 1.2;
                this.hoverAndZoom = this.platform == 1 ? false : true;
                break;
            case 'categoryHtml': case 'NORMALCATEGORY':
                this.bType = 'Categories';
                this.itensVp = this.platform == 1 ? 5 : 2.4;
                this.contentType  = 'categories'; 
                break;
            case 'pastime':    
                this.bType = 'RankingProducts';
                this.itensVp = this.platform == 1 ? 5 : 1.2;
                break;
            case 'DIAMOND':    
                this.bType = this.platform == 1 ? 'NormalProducts' : 'HorizontalProducts';
                this.itensVp = this.platform == 1 ? 5 : 1.2;
                break;                
        }
        
        //------
        if(this.sKey == 'HOMEPAGE_BLOCKS_CATEGORY_PRZ20124' || this.sKey == 'HOMEPAGE_BLOCKS_CATEGORY_PRZ20241' || this.sKey == 'HOMEPAGE_BLOCKS_CATEGORY_PRZ20405'){
            this.bType = 'VerticalProducts';
            this.itensVp = this.platform == 1 ? 5 : 1.2;
        }
        if(this.sKey == 'HOMEPAGE_BLOCKS_TRENDING_STORE_PRODUCT'  || this.sKey ==  'HOMEPAGE_BLOCKS_MOST_LIKED'){
            this.bType = 'RankingProducts';
            this.itensVp = this.platform == 1 ? 5 : 1.2;
        }
        if(this.sKey == 'HOMEPAGE_BLOCKS_CATEGORY_PRZ20314' && this.platform == 1 ){
            this.bType   = 'HorizontalProducts';
            this.itensVp = 2.5;
        }
        
        if(this.sKey == 'HOMEPAGE_BLOCKS_RECENTLY_VIEW_CUSTOMER' && this.platform == 1){
            this.bType   = 'NormalProducts';
            this.itensVp = 4;
        }
        if(this.sKey == 'HOMEPAGE_BLOCKS_NEW_PRODUCT' && this.platform == 2){
            this.bType = 'SlickProducts';
            this.itensVp = 1;
        }
        //------
    }

    get numberItens(){
        return this.itensVp;
    }

    get isHoverandZoomActivated(){
        return this.hoverAndZoom;
    }

    get type() {
        return this.bType;
    }

    get isDesktop(){
        return this.platform == 1;
    }

    get isMobile(){
        return this.platform != 1;
    }

    get snaps(){
        if(this.type == 'ComboProducts') {
            return Math.floor(this.CombosLength / Math.floor(this.itensVp)) + (this.CombosLength % Math.floor(this.itensVp) > 0 ? 1 : 0);
        }
        
        return Math.floor(this.length / Math.floor(this.itensVp)) + (this.length % Math.floor(this.itensVp) > 0 ? 1 : 0);
    }
    

    get elementId() {
        return `hblk${this.order}`;
    }

    get observeMargin(){
        let vpHt = homeUtils.getViewPortHeight();
        return vpHt * (this.platform == 1 ? 2 : 1);
    }

    //Monitor User Behavior data
    get mubData() {
        if(!this.mub || this.mub.t === 'products' || this.mub.t === 'combo'){
            // each product/combo will have it's own data
            return null;
        }

        let r = this.mub ? JSON.stringify(this.mub) : null;
        if(this.otiKey){
            r = r.replace(this.sKey,this.otiKey);
        }
        return r;
    }

    //Monitor User Behavior data (for button "View more")
    get mubDataViewMore() {
        if(!this.mub || !this.hasDiscovery){
            // block does not have "view more"
            return null;
        }

        return !this.mub ? null : {
            'b': this.otiKey ? this.otiKey : this.mub.b,
            't': 'buttonViewMore',
            'obs': false
        };
    }

    get anchor(){
        let hash = btoa(this.sKey);
        return hash.replace(/=/gi,'');
    }

    get matrix(){
        return this.matrixProds ? this.matrixProds : [];
    }

    get items(){
        return this.fillItens();
    }

    get length() {
        if(!this.dataContent && !this.diamond){
            return 0;
        }
        
        if(this.diamond){
            return this.diamond.data.length;
        }
        
        let hasAdvantagesBannerBlock = this.advantageWidthRate == 2;
        
        return this.dataContent.length + (this.hasDiscovery ? 1 : 0) + (this.hasAdvantages ? 1 : 0) + (hasAdvantagesBannerBlock ? 1 : 0);
    }

    get display() {
        return this.isLoading || (this.length >= this.min && this.length > 0) || this.type == 'SlideHtml';
    }

    get CombosLength() {
        if(!this.dataContent){
            return 0;
        }

        return Object.keys(this.dataContent).length;
    }

    get displayCombos() {
        if(!this.dataContent){
            return 0;
        }
        return this.isLoading || (this.CombosLength >= this.min);
    }

    get isLoading() {
        return this.loading;
    }

    get discovery() {
        return this.showMore;
    }

    get hasDiscovery() {
        return this.showMore && Object.keys(this.showMore).length;
    }
    
    get urlParams(){
        if(!browser.isIE()){
            let params = new URLSearchParams(window.location.search);
            let ccUp   = params.get('cache-update');
            if(ccUp){
                return {'cache-update':ccUp};
            }
        }
        return {};
    }

    get hasAdvantages(){
        return this.advantages !== null;
    }

    get advantagePosition(){
        return this.advantages && this.advantages.hasOwnProperty('position') ? this.advantages.position : null;
    }

    get advantageImage(){
        return this.advantages && this.advantages.hasOwnProperty('image') ? this.advantages.image : null;
    }

    get advantageWidthRate() {
        return this.advantages && this.advantages.hasOwnProperty('widthRate') ? this.advantages.widthRate : null;
    }

    get advantageZoom() {
        return this.advantages && this.advantages.hasOwnProperty('hasZoom') ? this.advantages.hasZoom : false;
    }
    set cache(data){
        try{
            if(this.ttl){
                let _myStorage = window.sessionStorage;
                let _time = this.ttl * 1000;

                //Set expiration time to max 15 minutes
                let _expi = Date.now() + (_time > 900000 ? 900000 : _time);
                let _data = JSON.stringify({expiration: _expi,data: data});
                _myStorage.setItem(this.key, _data);
            }
        }
        catch(err) {}
    }

    get cache(){
        try{
            if(this.ttl){
                let _myStorage = window.sessionStorage;
                let _data = _myStorage.getItem(this.key);
                let data  = JSON.parse(_data);
                if(data && data.hasOwnProperty('expiration')){
                    if(data.expiration > Date.now()){
                        return data.data;
                    }
                }
            }
        }
        catch(err) {}
        return null;
    }

    // get diamond(){
    //     return this.diamond;
    // }    

    fillMatrix(data){
        if(this.contentType != 'product' && this.contentType != 'combo'){
            return [];
        }
        let rst = [];
        let rItensVp = Math.floor(this.itensVp);
        let itens = this.type == 'ComboProducts' ? data : this.createStruct(data);
        
        for (let i = 0; i < this.snaps; i++) {
            rst[i + 1] = this.type != 'ComboProducts' ? itens.slice(i*rItensVp,(i*rItensVp)+rItensVp) : Object.values(itens).slice(i*rItensVp,(i*rItensVp)+rItensVp);
        }
        return rst;
    }

    fillItens(){
        if(!this.dataContent){
            return null;
        }
        return this.createStruct(this.dataContent);
    }

    createStruct(data){
        if(!data){
            return null;
        }
        if(this.blkitens === null){
            const len = (this.type == 'ComboProducts') ? this.CombosLength : (this.dataContent ? this.dataContent.length : 0);
            const setMub = this.sKey != 'PASTIME_BLOCKS_RANKING' && this.sKey != 'PASTIME_BLOCKS_RECENT';
            let itens = new Array();
            for (let i = 0; i < data.length; i++) {
                if(this.hasAdvantages && this.advantagePosition == (i + 1)){
                    itens.push(new homeAdvantage({
                        widthRate: this.advantageWidthRate,
                        image: this.advantageImage,
                        hasZoom: this.advantageZoom,
                    }));    
                }
                let p = new homeProduct(data[i]);
                p.numeration = i + 1;
                if(setMub){
                    p.setMubParent(this.mub, this.itensVp, len);
                }
                itens.push(p);
            }
            this.blkitens = itens;
        }
        return this.blkitens;
    }
    
    filterIncompleteCombos(data) {
        for(let i = 0; i < data.length; i++){
            if(data[i].products.length != 2){
                // combos must have 2 products
                continue;
            }

            // add MUB data
            data[i].mub = this.mub;
            // add metadata with current combo data
            data[i].mub.m = {groupId: data[i].groupIds, comboId: data[i].comboId};
            // add to list
            //combos.push(data);
        }
        //return combos;
        return Object.fromEntries(Object.entries(data).filter(([key, value]) => value.products.length == 2));
    }

    readCache(onlyEmpty){
        let _this = this;
        let cache  = this.cache;
        let params = this.urlParams;
        if(params.hasOwnProperty('cache-update')){
            return null;
        }
        if(cache && cache.hasOwnProperty('dataContent') && cache.hasOwnProperty('showMore') && cache.dataContent){
            if((cache.dataContent.length==0 && onlyEmpty) || !onlyEmpty){
                _this.dataContent = cache.dataContent;
                _this.matrixProds = _this.fillMatrix(_this.dataContent);
                _this.showMore    = cache.showMore;
                _this.loading     = false;
                if(cache.hasOwnProperty('title') && cache.title){
                    _this.title = cache.title;
                }
                if(cache.hasOwnProperty('otiKey') && cache.otiKey){
                    _this.otiKey = cache.otiKey;
                }
                return true;
            }
        }
        return false;
    }

    setData(data, saveOnCache){
        let _this = this;
        if(_this.type == 'ComboProducts') {
            _this.dataContent = data.hasOwnProperty('content') ? this.filterIncompleteCombos(data.content) : null;
        } else {
            _this.dataContent = data.hasOwnProperty('content') ? data.content : null;
        }
        _this.matrixProds = _this.fillMatrix(_this.dataContent);
        if(data.hasOwnProperty('showMore') && data.showMore){
            _this.showMore = data.showMore;
        }
        if(data.hasOwnProperty('title') && data.title){
            _this.title = data.title;
        }
        if(data.hasOwnProperty('otiKey') && data.otiKey){
            // update otiKey
            _this.otiKey = data.otiKey;
            // update block name in MUB data
            if(_this.mub && _this.mub.b && _this.mub.b != data.otiKey){
                _this.mub.b = data.otiKey;
            }
        }
        if(saveOnCache){
            _this.cache = {dataContent: _this.dataContent, showMore: _this.showMore, title: _this.title, otiKey: _this.otiKey};
        }
        _this.loading = false;
    }

    load() {        
        if(this.dataContent == null && !this.lock){
            let _this = this;
            if(this.readCache(false) && this.type != 'ComboProducts'){ // needs @sergio feedback
                return;
            }
            _this.lock = true;
            homeUtils.request(this.sKey,{data: this.key, type: this.type},this.urlParams,(response) => {
            //request.get(this.url,{...{data: this.key, type: this.type}, ...this.urlParams}).then( response => {
                //console.log('home blocks response.data', response.data);
                let data = response.data;
                if(data && !data.hasOwnProperty('error')){
                    _this.setData(data,true);
                }else{
                    _this.dataContent = null;
                }
                _this.loading = false;
                _this.lock = false;
            });
        }
        
    }

    initPastimeData(){
        // set data 
        this.dataContent = this.pastimeConfig.data;
        
        // setType
        let isRankingBlock = this.pastimeConfig && this.pastimeConfig.type == 'ranking';
        //let isRecentBlock = this.pastimeConfig && this.pastimeConfig.type == 'recent';
        this.bType = 'NormalProducts';
        if(isRankingBlock) {
            this.bType = this.platform == 1 ? 'RankingProducts' : 'SlickProducts';
        }
        this.itensVp = this.platform == 1 ? 5 : 1.2;
       /* if(isRecentBlock) {
            this.bType = 'NormalProducts';
        }*/
        // build matrix
        this.matrixProds = this.fillMatrix(this.pastimeConfig.data);
        // "unlock" block
        this.lock = false;
        // finished loading
        this.loading = false;
        this.hoverAndZoom = true;
    }

    initDiamondData(){
        // set data 
        this.dataContent = this.diamond.data;
        // build matrix
        this.matrixProds = this.fillMatrix(this.diamond.data);
        // "unlock" block
        this.lock = true;
        // finished loading
        this.loading = false;
        // don't zoom when mouse is over
        this.hoverAndZoom = false;
    }
}
